import { render, staticRenderFns } from "./MaisDetalhes.vue?vue&type=template&id=164d87ee"
import script from "./MaisDetalhes.vue?vue&type=script&setup=true&lang=js"
export * from "./MaisDetalhes.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports